


import { createAction as ngrxCreateAction, props, Action } from '@ngrx/store';

export const INIT_SCREEN = '[Master compArrayFormClients] Init';
export const DESTROY_SCREEN = '[Master compArrayFormClients] Destroy';

export const INIT_STATE = '[Master compArrayFormClients] Init State';
export const INIT_VALUE = '[Master compArrayFormClients] Init Value';
export const INIT_VALUE_SUCCESS = '[Master compArrayFormClients] Init Value Success';
export const INIT_VALUE_FAIL = '[Master compArrayFormClients] Init Value Fail';
export const FETCH_FIELD_POSSIBLE_VALUES =
  '[Master comp-array-form-clients] Fetch Field Possible Values';
export const FETCH_FIELD_POSSIBLE_VALUES_SUCCESS =
  '[Master comp-array-form-clients] Fetch Field Possible Values Success';
export const FETCH_FIELD_POSSIBLE_VALUES_FAIL =
  '[Master comp-array-form-clients] Fetch Field Possible Values Fail';

export const UPDATE_DATA = "[Master compArrayFormClients] Update Data";




export const initAction = ngrxCreateAction(INIT_SCREEN, payload => payload);

export const destroyAction = ngrxCreateAction(DESTROY_SCREEN, payload => payload);






export const initStateAction = ngrxCreateAction(INIT_STATE,payload => payload);

export const initValueAction = ngrxCreateAction(INIT_VALUE,payload => payload);

export const initValueSuccessAction = ngrxCreateAction(INIT_VALUE_SUCCESS,payload => payload);

export const initValueFailAction = ngrxCreateAction(INIT_VALUE_FAIL,payload => payload);
export const fetchFieldPossibleValuesAction = ngrxCreateAction(FETCH_FIELD_POSSIBLE_VALUES,payload => payload);
export const fetchFieldPossibleValuesSuccessAction = ngrxCreateAction(FETCH_FIELD_POSSIBLE_VALUES_SUCCESS,payload => payload);
export const fetchFieldPossibleValuesFailAction = ngrxCreateAction(FETCH_FIELD_POSSIBLE_VALUES_FAIL,payload => payload);





export const updateDataAction = ngrxCreateAction(
  UPDATE_DATA,
  payload => payload
);

